import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Transient state for the "Take a Tour" feature. Holds the id of the tour the
 * user has requested; `TourHost` watches it, navigates to the tour's route if
 * needed, and runs the driver.js walkthrough. In-memory only — whether a tour
 * has been *seen* is persisted separately in localStorage (see `tourStorage`).
 */
interface TourState {
  requestedTourId: string | null;
}

const initialState: TourState = {
  requestedTourId: null,
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    requestTour(state, action: PayloadAction<string>) {
      state.requestedTourId = action.payload;
    },
    clearTour(state) {
      state.requestedTourId = null;
    },
  },
});

export const { requestTour, clearTour } = tourSlice.actions;
export default tourSlice.reducer;
